export default {
  async actionGetAllSupportSettings({ commit }, params) {
    const { data } = await this.$services._core.supportSettings().getAllSupportSettings(params);
    commit('SET_SUPPORT_SETTINGS', data);
    return data;
  }
};
